// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountMenuButton-cls1_MBS","cls2":"AccountMenuButton-cls2_Ez1 AccountMenuButton-cls1_MBS"};